webpackJsonp([18,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _userServices = __webpack_require__(25);
	
	var _userServices2 = _interopRequireDefault(_userServices);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Shared = __webpack_require__(8);
	var LanguageManager = __webpack_require__(6);
	var utils = __webpack_require__(2);
	
	__webpack_require__(607);
	
	$(function () {
	  Shared.init();
	  ResetPasswordPage.init();
	});
	
	var ResetPasswordPage = {};
	
	(function (ResetPasswordPage) {
	
	  ResetPasswordPage.init = function () {
	    setUpEventListeners();
	    clearAllFieldErrors();
	  };
	
	  function setUpEventListeners() {
	    showEnterEmailPart();
	
	    var $cancelResetPasswordBtn = $("#cancel-reset-password-btn");
	
	    $cancelResetPasswordBtn.on("click", function () {
	      utils.redirect("/login");
	    });
	
	    $("#send-reset-mail-btn").on("click", function (e) {
	      var emailEl = $("#email-input").removeClass("input-error");
	      var email = emailEl.val();
	
	      if (utils.isNullOrEmpty(email)) {
	        emailEl.addClass("is-invalid");
	
	        e.preventDefault();
	        return;
	      }
	
	      var $this = $(this);
	      $this.prop("disabled", true).removeClass("btn-loading").addClass("btn-loading");
	
	      _userServices2.default.requestPasswordReset(email).then(function (data) {
	        $this.prop("disabled", false).removeClass("btn-loading");
	        showEmailSentPart(email);
	
	        emailEl.val("");
	      }).catch(function (err) {
	        var message = LanguageManager.getValueForKey(err.readableErrorMessage);
	        $("#reset-password-email-input-error").text(message);
	
	        $this.prop("disabled", false).removeClass("btn-loading");
	      });
	    });
	
	    $("#reset-password-resend-btn").on("click", function () {
	      showEnterEmailPart();
	    });
	    $("#reset-password-to-login-btn").on("click", function () {
	      utils.redirect("/login");
	    });
	  }
	
	  function showEnterEmailPart() {
	    $("#part_enter_email").show();
	    $("#part_mail_sent").hide();
	  }
	
	  function showEmailSentPart(email) {
	    var message = LanguageManager.getValueForKey("reset_password.mail_sent_to");
	    var formattedMessage = utils.format(message, [email]);
	    $("#part_mail_sent_message").html(formattedMessage);
	
	    $("#part_enter_email").hide();
	    $("#part_mail_sent").show();
	  }
	
	  function clearAllFieldErrors() {
	    $(".form-control").removeClass("is-invalid");
	    $(".input-field-error").text("");
	  }
	})(ResetPasswordPage);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./nl-BE.json": 11
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 10;


/***/ }),

/***/ 607:
107

});


// WEBPACK FOOTER //
// js/reset-password.d45174dc87a623d99888.js